import { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';
import Tooltip from '@components/common/Tooltip';

const SizeMixedChart = () => {
    const chartRef = useRef<HTMLDivElement>(null);
    const chartInstance = useRef<ApexCharts | null>(null);

    useEffect(() => {
        if (!chartRef.current) return;

        const options = {
            series: [3.37, 6.15, 1.0, 18.4],
            labels: ['잎줄기', '수확물', '뿌리', '흡수량'],
            chart: {
                height: 176,
                type: 'donut',
                dropShadow: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    top: 5,
                    left: 0,
                    blur: 3,
                    color: '#000',
                    opacity: 0.1,
                },
            },
            dataLabels: {
                enabled: false,
            },

            legend: {
                show: false,
            },
            stroke: {
                show: true,
                curve: 'smooth',
                lineCap: 'round',
                colors: '#fff',
                width: 0,
                dashArray: 0,
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                    donut: {
                        size: '70%',
                        background: 'transparent',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '20px',
                                color: '#495057',
                                offsetY: -4,
                            },
                            value: {
                                show: true,
                                fontSize: '18px',
                                offsetY: 8,
                                formatter: function (val: string) {
                                    return val + '%';
                                },
                            },
                            total: {
                                show: true,
                                showAlways: true,
                                label: '흡수량',
                                fontSize: '22px',
                                fontWeight: 600,
                                color: '#495057',
                                formatter: function (data: any) {
                                    return data.globals.series[3] + '%';
                                },
                            },
                        },
                    },
                },
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (val: number) {
                        return val + '%';
                    },
                },
            },
            colors: [
                'var(--primary-color)',
                'rgba(var(--secondary-rgb), 0.9)',
                'rgba(var(--success-rgb), 0.85)',
                'rgba(var(--info-rgb), 0.7)',
            ],
        };

        chartInstance.current = new ApexCharts(chartRef.current, options);
        chartInstance.current.render();

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);

    return (
        <div className="custom-card card">
            <div className="justify-content-between card-header">
                <div className="card-title">
                    작물양분-질소
                    <Tooltip
                        content="도움말이 표시될예정"
                        customClass="tooltip-dark"
                        placement="top"
                    >
                        <i className="ri-question-line" />
                    </Tooltip>
                </div>
                <div>
                    <button
                        type="button"
                        className="btn-wave  btn-sm btn-wave waves-effect waves-light btn btn-success-light"
                    >
                        더보기
                        <i className="ri-more-line"></i>
                    </button>
                </div>
            </div>

            <div ref={chartRef} className="mt-4" style={{}}></div>

            <div className="card-body">
                <div className="row-cols-12 row">
                    <div className="p-0 col">
                        <div className="text-center">
                            <div className="mb-2">
                                <i className="ri-check-line p-2 fs-15 bg-info-transparent rounded-circle lh-1 align-middle"></i>
                            </div>
                            <div className="text-muted fs-12 mb-1 hrm-jobs-legend job boards d-inline-block ">
                                흡수량
                            </div>
                            <div>
                                <span className="fs-16 fw-semibold">18.4%</span>
                            </div>
                        </div>
                    </div>
                    <div className="p-0 col">
                        <div className="text-center">
                            <div className="mb-2">
                                <i className="ri-check-line p-2 fs-15 bg-success-transparent rounded-circle lh-1 align-middle"></i>
                            </div>
                            <div className="text-muted fs-12 mb-1 hrm-jobs-legend referrals d-inline-block ">
                                뿌리
                            </div>
                            <div>
                                <span className="fs-16 fw-semibold">1.0%</span>
                            </div>
                        </div>
                    </div>
                    <div className="p-0 col">
                        <div className="text-center">
                            <div className="mb-2">
                                <i className="ri-check-line p-2 fs-15 bg-secondary-transparent rounded-circle lh-1 align-middle"></i>
                            </div>
                            <div className="text-muted fs-12 mb-1 hrm-jobs-legend media d-inline-block ">
                                수확물
                            </div>
                            <div>
                                <span className="fs-16 fw-semibold">6.15%</span>
                            </div>
                        </div>
                    </div>
                    <div className="p-0 col">
                        <div className="text-center">
                            <div className="mb-2">
                                <i className="ri-check-line p-2 fs-15 bg-primary-transparent rounded-circle lh-1 align-middle"></i>
                            </div>
                            <div className="text-muted fs-12 mb-1 hrm-jobs-legend campus d-inline-block ">
                                잎줄기
                            </div>
                            <div>
                                <span className="fs-16 fw-semibold">3.37%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SizeMixedChart;
